import React, {useContext, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {ADotLoader, ATextInput} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {useSelector} from "react-redux";
import FilterChips from "features/incidents/IncidentsFilter/FilterChips";
// eslint-disable-next-line max-len
import FilterMenuDropdown from "features/incidents/IncidentsFilter/FilterMenuDropdown";
import styles from "./TableFilter.module.scss";

const TableFilter = ({
  className,
  name,
  loadingSelector,
  totalDisplay,
  dropdown = false,
  filterChips = false,
  context
}) => {
  const inputRef = useRef(null);

  const {searchQuery = "", handleSearchTextChange} = useContext(context);

  const [searchInputVal, setSearchInputVal] = useState("");
  const isLoading = useSelector(loadingSelector);

  let timer;

  useEffect(() => {
    setSearchInputVal(searchQuery);
  }, [searchQuery]);

  const handleChange = (e) => {
    clearTimeout(timer);
    setSearchInputVal(e.target.value);
    timer = setTimeout(() => {
      handleSearchTextChange(e.target.value);
      inputRef.current.focus();
    }, 3000);
  };

  const handleKeyUp = (e) => {
    if (e.keyCode === 13 || e.key === "Enter") {
      clearTimeout(timer);
      handleSearchTextChange(e.target.value);
    }
  };

  return (
    <div
      className={classNames(
        `${name}-table-filter`,
        "d-flex",
        "align-start",
        className
      )}>
      <div className={"d-flex align-start"}>
        <ATextInput
          medium
          ref={inputRef}
          value={searchInputVal}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          prependIcon="magnifying-glass"
          placeholder="Search"
          clearable
          // eslint-disable-next-line max-len
          disabled={false} // TODO: use isLoading instead of false once user selection bug is fixed in ATextInput
          style={{width: 240, minWidth: 240}}
        />
        <div className={styles.resultsContainer}>
          {isLoading ? (
            <ADotLoader className="mx-2 my-0 align-self-center" />
          ) : (
            totalDisplay
          )}
        </div>
        {dropdown && <FilterMenuDropdown />}
        {filterChips && <FilterChips />}
      </div>
    </div>
  );
};

TableFilter.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  loadingSelector: PropTypes.func,
  totalDisplay: PropTypes.node,
  dropdown: PropTypes.bool,
  filterChips: PropTypes.bool,
  context: PropTypes.object
};

export default TableFilter;
